import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=bc04b74a&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc04b74a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc04b74a')) {
      api.createRecord('bc04b74a', component.options)
    } else {
      api.reload('bc04b74a', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=bc04b74a&scoped=true&", function () {
      api.rerender('bc04b74a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2caR9Div76bWR/JS/comp/SearchFilterTokens.vue"
export default component.exports